/* eslint-disable no-console */
import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { currentUser } from 'js/utils/user';
import * as ApiUtils from 'js/utils/api_utils';

export const addCV = async (file?: File | null) => {
  if (!file) return;
  const formData = new FormData();
  formData.append('files[]', file);
  const response = await fetchWithCsrf(
    routes.new_profile_curriculum_vitae_path({
      page_name: currentUser?.page_name,
    }),
    { method: 'POST', body: formData },
  );
  if (!response.ok) {
    throw new Error('Failed to update CV');
  }
};

export const deleteCV = async () => {
  const url = routes.new_profile_curriculum_vitae_path({
    page_name: currentUser?.page_name,
  });

  const response = await ApiUtils.deleteRequest(url);

  if (!response.ok) {
    throw new Error('Failed to delete CV');
  }
};

export const checkCVExists = async () => {
  try {
    const url = routes.new_profile_curriculum_vitae_path({
      page_name: currentUser?.page_name,
    });

    // Using HEAD request to avoid downloading the entire page
    const response = await fetch(url, { method: 'HEAD' });
    return response.status === 200;
  } catch (error) {
    console.error('Error checking CV existence:', error);
    return false;
  }
};
